module.exports = __webpack_public_path__ + "img/home_20.88ddec7f.png";